// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3bd9cf66","239":"37ab0bda","453":"7270ae63","455":"3be362be"}[chunkId] + ".chunk.js";
};